const state = {
  itemSelect: {},
  fts: {
    fts: "",
    who: "",
  },
};

export default state;
